"use client"

import type { ReactNode } from "react"
import { usePathname } from "next/navigation"

import { FooterContactSection } from "@/components/landing/footer-contact-section"
import { Header } from "@/components/landing/header"

type MarketingLayoutFrameProps = {
  children: ReactNode
  locale: string
}

export function MarketingLayoutFrame({
  children,
  locale,
}: MarketingLayoutFrameProps) {
  const pathname = usePathname()
  const safePathname = pathname
  const isEventRoute = Boolean(safePathname.match(/\/(?:event|webinar)(\/|$)/))

  return (
    <>
      {isEventRoute ? null : <Header />}
      {children}
      {isEventRoute ? null : <FooterContactSection locale={locale} />}
    </>
  )
}
